/*!
 * Copyright © 2021. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EVideoChannel {
  FrontFacing = 1,
  DriverFacing = 2
}
